var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.50904 2.67871L8.75677 10.6954H3.24477L2.49337 2.67871L1.54004 2.75671L2.30531 10.919C2.33352 11.1083 2.42978 11.2809 2.57607 11.4044C2.72236 11.5278 2.90864 11.5938 3.10004 11.5898H8.90151C9.09371 11.5932 9.28054 11.5263 9.42689 11.4016C9.57323 11.277 9.66902 11.1032 9.69624 10.9129L10.4615 2.75584L9.50904 2.67871Z",
    fill: "#EF717D",
    stroke: "#EF717D",
    strokeWidth: 0.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.75308 0.40918H4.24655C4.03515 0.409409 3.83248 0.493487 3.683 0.642967C3.53352 0.792446 3.44945 0.995118 3.44922 1.20651V2.72058H4.40254V1.36251H7.59015V2.72058H8.54348V1.20651C8.54349 0.996243 8.46044 0.794482 8.31241 0.64515C8.16438 0.495819 7.96334 0.411008 7.75308 0.40918Z",
    fill: "#EF717D",
    stroke: "#EF717D",
    strokeWidth: 0.3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1011 2.24246H0.900436C0.834422 2.23682 0.767957 2.24496 0.705253 2.26635C0.642549 2.28775 0.584973 2.32194 0.536173 2.36675C0.487373 2.41156 0.448413 2.46602 0.421761 2.52668C0.39511 2.58734 0.381348 2.65287 0.381348 2.71912C0.381348 2.78537 0.39511 2.85091 0.421761 2.91157C0.448413 2.97222 0.487373 3.02668 0.536173 3.07149C0.584973 3.11631 0.642549 3.1505 0.705253 3.17189C0.767957 3.19329 0.834422 3.20142 0.900436 3.19579H11.1011C11.1671 3.20142 11.2336 3.19329 11.2963 3.17189C11.359 3.1505 11.4166 3.11631 11.4654 3.07149C11.5142 3.02668 11.5531 2.97222 11.5798 2.91157C11.6064 2.85091 11.6202 2.78537 11.6202 2.71912C11.6202 2.65287 11.6064 2.58734 11.5798 2.52668C11.5531 2.46602 11.5142 2.41156 11.4654 2.36675C11.4166 2.32194 11.359 2.28775 11.2963 2.26635C11.2336 2.24496 11.1671 2.23682 11.1011 2.24246Z",
    fill: "#EF717D",
    stroke: "#EF717D",
    strokeWidth: 0.3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.0331 6.05908H4.88897C4.55104 6.05908 4.2771 6.33302 4.2771 6.67095V6.67182C4.2771 7.00974 4.55104 7.28368 4.88897 7.28368H7.0331C7.37102 7.28368 7.64497 7.00974 7.64497 6.67182V6.67095C7.64497 6.33302 7.37102 6.05908 7.0331 6.05908Z",
    fill: "#EF717D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.03298 6.18945H4.88885C4.62272 6.18945 4.40698 6.40519 4.40698 6.67132V6.67219C4.40698 6.93831 4.62272 7.15405 4.88885 7.15405H7.03298C7.29911 7.15405 7.51485 6.93831 7.51485 6.67219V6.67132C7.51485 6.40519 7.29911 6.18945 7.03298 6.18945Z",
    stroke: "#EF717D",
    strokeWidth: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.a8db6547109107f596057763f53141b0.svg";
export { ForwardRef as ReactComponent };